import React, { useContext, useEffect, useState } from 'react';
import './stoppedTime.css';
import ItemList from '../../components/sections/itemList';
import DateRangeSelector from '../../components/sections/dateRangeSelector';
import Loader from '../../components/loader';
import { filterStoppedTimeReport, formatDateRange, subtractDays } from '../../utils/generalFunctions';
import RetryReport from '../../components/retryReport';
import { DateContext } from '../../context/dateProvider';

const StoppedTime = ({ dataReport, devices, updateDevices, progress, error, fetchReport, userConstants, updateUserConstants, isRecoveredReports }) => {
    const { startDate, endDate, today,
        yesterday,
        startActualWeek,
        endActualWeek,
        startPreviousWeek,
        endPreviousWeek,
        startActualMonth,
        endActualMonth,
        startPreviousMonth,
        endPreviousMonth,
    } = useContext(DateContext);

    const [isLoading, setIsLoading] = useState(true);
    const [engineData, setEngineData] = useState(isRecoveredReports && userConstants.reports && userConstants.reports.foundReports ? userConstants.reports.stoppedTimeData : []);
    const [showAllTop, setShowAllTop] = useState(false);
    const [dateTopRange, setDateTopRange] = useState(0);
    const [totalData, setTotalData] = useState(isRecoveredReports && userConstants.reports && userConstants.reports.foundReports ? userConstants.reports.stoppedTimeTotalData : {});
    const [displayedDurationData, setDisplayedDurationData] = useState([]);

    useEffect(() => {
        if (!dataReport || dataReport.length === 0) return;
        setIsLoading(true);

        const processedData = filterStoppedTimeReport(dataReport, startPreviousMonth, endDate);

        setEngineData(processedData);

        // // Acumulación de datos por periodo
        // let accumulatedData = {
        //     "Hoy": {},
        //     "Ayer": {},
        //     "Semana actual": {},
        //     "Semana previa": {},
        //     "Mes actual": {},
        //     "Mes previo": {}
        // };

        // const addDataToPeriod = (period, carName, data) => {
        //     if (!accumulatedData[period][carName]) {
        //         accumulatedData[period][carName] = {
        //             ignition_on: 0,
        //             idle_duration: 0,
        //             ignition_on_percent: 0,
        //         };
        //     }

        //     accumulatedData[period][carName].ignition_on += Number(data.ignition_on || 0);
        //     accumulatedData[period][carName].idle_duration += Number(data.idle_duration || 0);
        //     accumulatedData[period][carName].ignition_on_percent += Number(data.ignition_on_percent || 0);
        // };

        // processedData.forEach(obj => {
        //     const entryDate = obj.date;

        //     Object.keys(obj).forEach(carName => {
        //         if (carName !== 'date') {
        //             const data = obj[carName] || { ignition_on: 0, idle_duration: 0, ignition_on_percent: 0 };

        //             if (entryDate.toDateString() === today.toDateString()) {
        //                 addDataToPeriod("Hoy", carName, data);
        //             } else if (entryDate.toDateString() === yesterday.toDateString()) {
        //                 addDataToPeriod("Ayer", carName, data);
        //             }

        //             if (entryDate >= startActualWeek && entryDate <= endActualWeek) {
        //                 addDataToPeriod("Semana actual", carName, data);
        //             }

        //             if (entryDate >= startActualMonth && entryDate <= endActualMonth) {
        //                 addDataToPeriod("Mes actual", carName, data);
        //             }

        //             if (entryDate >= startPreviousWeek && entryDate <= endPreviousWeek) {
        //                 addDataToPeriod("Semana previa", carName, data);
        //             }

        //             if (entryDate >= startPreviousMonth && entryDate <= endPreviousMonth) {
        //                 addDataToPeriod("Mes previo", carName, data);
        //             }
        //         }
        //     });
        // });

        const accumulatedData = calculateTotal(processedData);
        setTotalData(accumulatedData);

        updateUserConstants({ "reports.stoppedTimeData": processedData, "reports.stoppedTimeTotalData": accumulatedData });

        setIsLoading(false);
    }, [dataReport]);

    const calculateTotal = (engineData) => {
        let accumulatedData = {
            "Hoy": {},
            "Ayer": {},
            "Semana actual": {},
            "Semana previa": {},
            "Mes actual": {},
            "Mes previo": {}
        };

        const addDataToPeriod = (period, carName, data) => {
            if (!accumulatedData[period][carName]) {
                accumulatedData[period][carName] = {
                    ignition_on: 0,
                    idle_duration: 0,
                    ignition_on_percent: 0,
                };
            }

            accumulatedData[period][carName].ignition_on += Number(data.ignition_on || 0);
            accumulatedData[period][carName].idle_duration += Number(data.idle_duration || 0);
            accumulatedData[period][carName].ignition_on_percent += Number(data.ignition_on_percent || 0);
        };

        engineData.forEach(obj => {
            const entryDate = new Date(obj.date);

            Object.keys(obj).forEach(carName => {
                if (carName !== 'date') {
                    const data = obj[carName] || { ignition_on: 0, idle_duration: 0, ignition_on_percent: 0 };

                    if (entryDate.toDateString() === today.toDateString()) {
                        addDataToPeriod("Hoy", carName, data);
                    } else if (entryDate.toDateString() === yesterday.toDateString()) {
                        addDataToPeriod("Ayer", carName, data);
                    }

                    if (entryDate >= startActualWeek && entryDate <= endActualWeek) {
                        addDataToPeriod("Semana actual", carName, data);
                    }

                    if (entryDate >= startActualMonth && entryDate <= endActualMonth) {
                        addDataToPeriod("Mes actual", carName, data);
                    }

                    if (entryDate >= startPreviousWeek && entryDate <= endPreviousWeek) {
                        addDataToPeriod("Semana previa", carName, data);
                    }

                    if (entryDate >= startPreviousMonth && entryDate <= endPreviousMonth) {
                        addDataToPeriod("Mes previo", carName, data);
                    }
                }
            });
        });

        return accumulatedData;
    };

    useEffect(() => {
        const newTotalData = calculateTotal(engineData);
        setTotalData(newTotalData);
    }, [today, yesterday, startActualWeek, endActualWeek, startPreviousWeek, endPreviousWeek]);

    const handleShowAllTopToggle = () => {
        setShowAllTop(!showAllTop);
    };

    const getStoppedTimeByDateRange = (range) => {
        let periodCurrentData = {}, periodPreviousData = {};

        switch (range) {
            case 0:
                periodCurrentData = totalData['Hoy'] || {};
                periodPreviousData = totalData['Ayer'] || {};
                break;
            case 1:
                periodCurrentData = totalData['Semana actual'] || {};
                periodPreviousData = totalData['Semana previa'] || {};
                break;
            case 2:
                periodCurrentData = totalData['Mes actual'] || {};
                periodPreviousData = totalData['Mes previo'] || {};
                break;
            default:
                return [];
        }

        // Filtramos dispositivos visibles
        const visibleDevices = devices.filter(device => device.visible);

        const combinedData = Object.keys({ ...periodCurrentData, ...periodPreviousData })
            .filter(car => visibleDevices.find(device => device.label === car))  // Filtra solo los visibles
            .map((car) => {
                const current = periodCurrentData[car] || { ignition_on: 0, idle_duration: 0, ignition_on_percent: 0 };
                const previous = periodPreviousData[car] || { ignition_on: 0, idle_duration: 0, ignition_on_percent: 0 };

                return {
                    car,
                    currentIgnitionOn: current.ignition_on,
                    currentIdleDuration: current.idle_duration,
                    currentIgnitionOnPercent: current.ignition_on_percent,
                    previousIgnitionOn: previous.ignition_on,
                    previousIdleDuration: previous.idle_duration,
                    previousIgnitionOnPercent: previous.ignition_on_percent
                };
            });

        return combinedData;
    };

    useEffect(() => {
        const sortedByDuration = getStoppedTimeByDateRange(dateTopRange)
            .sort((a, b) => {
                if (b.currentIdleDuration === a.currentIdleDuration) {
                    return b.previousIdleDuration - a.previousIdleDuration;
                }
                return b.currentIdleDuration - a.currentIdleDuration;
            });
        setDisplayedDurationData(showAllTop ? sortedByDuration : sortedByDuration.slice(0, 5));
    }, [devices, totalData, dateTopRange, showAllTop]);


    const totalItems = displayedDurationData.length;

    // Calcular el ancho basado en la cantidad de dígitos
    const indexWidth = totalItems < 10 ? '2ch' : totalItems < 100 ? '3ch' : '4ch';

    const [cardsReady, setCardsReady] = useState([]);

    useEffect(() => {
        const totalCards = 1; // Cambiar este número según la cantidad de tarjetas
        if (progress === 100) {
            // Generar tiempos aleatorios para cada tarjeta
            const randomDelays = Array.from({ length: totalCards }, () => Math.random() * 2000 + 1000); // 1-3 segundos
            const timeouts = randomDelays.map((delay, index) => {
                return setTimeout(() => {
                    setCardsReady((prev) => {
                        const updated = [...prev];
                        updated[index] = true;
                        return updated;
                    });
                }, delay);
            });

            // Limpiar los timeouts al desmontar
            return () => timeouts.forEach((timeout) => clearTimeout(timeout));
        } else {
            setCardsReady(new Array(totalCards).fill(false));
        }
    }, [progress]);

    return (
        <div className='section_grid_container'>

            <div className='dashboard_card card_top_large card_short'>
                {error ?
                    <RetryReport fetchReport={fetchReport} sectionNum={1} />
                    :
                    progress < 100 || !cardsReady[0] ? (
                        <Loader progress={progress} />
                    ) : (
                        <>
                            <div className='card_header_flex'>
                                <div className='dashboard_card_header_container'>
                                    <span className='dashboard_card_title'>{showAllTop ? 'Todos los' : 'Top 5'} vehículos con mayor tiempo detenido</span>
                                    <button className='dashboard_card_view_more' onClick={handleShowAllTopToggle}>
                                        {showAllTop ? 'Ver menos' : 'Ver todos'}
                                    </button>
                                </div>
                                <div className='card_config_container'>
                                    <DateRangeSelector dateRange={dateTopRange} setDateRange={setDateTopRange} />
                                </div>
                            </div>
                            <div className='dashboard_card_content_container'>
                                <div className='top_items_container' style={{ '--item-index-width': indexWidth }}>
                                    <div className='top_items_header_container'>
                                        <span>Periodo</span>
                                        <span>Actual<br /><span>({formatDateRange(dateTopRange, today, startActualWeek, endActualWeek, startActualMonth, endActualMonth)})</span></span>
                                        <span>Previo<br /><span>({formatDateRange(dateTopRange, yesterday, startPreviousWeek, endPreviousWeek, startPreviousMonth, endPreviousMonth)})</span></span>
                                    </div>
                                    {
                                        displayedDurationData.length === 0 ?
                                            <span className='text_no_vehicles'>Ningún vehículo seleccionado</span>
                                            :
                                            displayedDurationData.map((item, index) => (
                                                <ItemList
                                                    key={index}
                                                    index={index + 1}
                                                    type={'stoppedTime'}
                                                    name={item.car}
                                                    data={{
                                                        currentIdleDuration: item.currentIdleDuration,
                                                        previousIdleDuration: item.previousIdleDuration,
                                                    }}
                                                />
                                            ))
                                    }
                                </div>
                            </div>
                        </>
                    )}
            </div>
            {/* <div style={{ height: '200px', overflow: 'auto' }} onClick={(e) => {
          const range = document.createRange();
          const selection = window.getSelection();
          range.selectNodeContents(e.target);
          selection.removeAllRanges();
          selection.addRange(range);
        }}><pre>{JSON.stringify(dataReport, 0, 2)}</pre></div> */}
        </div>
    )
}

export default StoppedTime
